import { RestSlice } from '../../../../../redux/rest.slice';
import { IppUser } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippUserSlice = new RestSlice<IppUser>(
	localizationService.getLocalizedString('ipp.authorityAccount.users'),
	Resource.IppUsers
);
export default ippUserSlice.rests.reducer;
